import { useContext, useEffect } from 'react'

import ExternalServicesContext from 'contexts/ExternalServicesContext'

import * as service from 'service'
import constants from 'constants/index'

const { REACHABILITY } = constants.externalServices

// Recebe as keys de que uma superfície depende e devolve os hosts que este
// navegador não alcançou, para a mensagem nomear quem caiu em vez de dizer
// "algo falhou".
const useUnreachableServices = (keys = []) => {
  const context = useContext(ExternalServicesContext)

  if (context === undefined) {
    throw new Error(
      'useUnreachableServices must be used within an ExternalServicesContext.Provider',
    )
  }

  const { catalog, reachabilityByKey, probeOnce, recheck } = context

  // `keys` costuma chegar como literal novo a cada render: é a serialização, e
  // não o array, que estabiliza o efeito.
  const serializedKeys = keys.join(',')

  useEffect(() => {
    keys.forEach((key) => {
      if (catalog[key]) probeOnce(key)
    })
    //eslint-disable-next-line
  }, [serializedKeys, catalog])

  const unreachableKeys = keys.filter(
    (key) => reachabilityByKey[key] === REACHABILITY.UNREACHABLE,
  )

  // Um serviço bloqueado sem host resolvido segue bloqueando: por isso o gate
  // olha as keys, e só a mensagem olha os hosts.
  const unreachableHosts = unreachableKeys
    .map((key) => service.externalServices.reachability.hostFor(catalog[key]))
    .filter(Boolean)

  return {
    unreachableHosts,
    hasUnreachable: unreachableKeys.length > 0,
    recheckAll: () => Promise.all(keys.map((key) => recheck(key))),
  }
}

export default useUnreachableServices
